import { APP_NAME, APP_VERSION } from '@/utils/navigation'

export function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="border-border text-muted-foreground mt-auto border-t px-4 py-4 text-xs sm:px-6">
      <div className="mx-auto flex max-w-[1400px] flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
        <p>
          © {year} {APP_NAME} · Master Informática
        </p>
        <p className="text-[11px]">
          Sprint 2.9 · v{APP_VERSION} · MasterHub AI
        </p>
      </div>
    </footer>
  )
}
